import * as types from "./types";

export const vatInitialState = {
  //post request of user
  vatPost: null,
  vatPostLoading: false,
  vatPostError: null,
  vatGetLoading: false,
  vatGetError:null,
  vat: <any>[]
};

export const vatReducer = (state = vatInitialState, action: any) => {
  switch (action.type) {
    case types.VAT_POST_START:
      return {
        ...state,
        vatPostLoading: true,
      };
    case types.VAT_POST_SUCCESS:
      return {
        ...state,
        vat: [...state.vat, action.vat],
        vatPostLoading: false,
      };

    case types.VAT_POST_FAILURE:
      return {
        ...state,
        userPostError: action.userPostError,
        vatPostLoading: false,
      };

    case types.ALL_VAT_GET_FETCH_START:
      return {
        ...state,
        vatGetLoading: true,
      };
    case types.ALL_VAT_GET_FETCH_SUCCESS:
      return {
        ...state,
        vat: action.vat,
        vatGetLoading: false,
      };

    case types.ALL_VAT_GET_FETCH_FAILURE:
      return {
        ...state,
        vatGetError: action.vatGetError,
        vatPostLoading: false,
      };

    default:
      return state;
  }
};
